module.exports = __webpack_public_path__ + "img/Group140.b861f492.png";